import { injectable } from 'tsyringe'
import { HomebannerApiRepository } from '@/app/repositories/api/HomebannerApiRepository'
import { Homebanner } from '@/domain/entities/Homebanner'
import {
  PostHomebannerInterface,
  DeleteHomebannerInterface,
  UpdateHomebannerInterface,
} from '@/data/payload/contracts/HomebannerRequest'
@injectable()
export class HomebannerPresenter {
  private repository: HomebannerApiRepository

  constructor(repository: HomebannerApiRepository) {
    this.repository = repository
  }

  public loadHomebanner(params: Object): Promise<Homebanner> {
    return this.repository.getAll(params)
  }

  public postHomebanner(payload: PostHomebannerInterface): Promise<Homebanner> {
    return this.repository.post(payload)
  }

  public updateHomebanner(
    payload: UpdateHomebannerInterface,
    id: number
  ): Promise<Homebanner> {
    return this.repository.update(payload, id)
  }

  public deleteHomebanner(
    payload: DeleteHomebannerInterface
  ): Promise<Homebanner> {
    return this.repository.delete(payload)
  }
}
